import React from 'react';
import { motion } from 'framer-motion';
import { isEmpty } from 'lodash';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Link from '../layouts/Link';


export default function FooterDesktopMenu({ data, lightLogo }) {
  const lastTwo = data.slice(-2);

  return (
    <div
      className="sm:flex flex-col 4xl:gap-x-[157px] 2xl:gap-x-[90px] xl:gap-x-[50px] gap-x-[80px]
      lg:pt-[221px] lg:pb-[159px] pt-[100px] pb-[90px] hidden gap-y-16 md2:flex-row">
      <motion.div
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4, delay: 0.3 }}
        viewport={{ once: true }}>
        <Link to="/">
          {isEmpty(lightLogo) || (
            <LazyLoadImage
              src={lightLogo.url}
              className="4xl:min-w-[207px] 3xl:w-[170px] xs2:w-[150px] 4xl:h-[119px] h-auto"
            />
          )}
        </Link>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4, delay: 0.5 }}
        viewport={{ once: true }}
        className="flex flex-nowrap 4xl:gap-x-[45px] 2xl:gap-x-[27px] gap-x-[24px]
        gap-y-[50px] justify-between w-full max-w-[1100px]">
        {isEmpty(data) ||
          data.map(
            (item, index) =>
              data.length - 2 > index && (
                <div className="flex flex-col gap-y-[18px] " key={index}>
                  {isEmpty(item.content.urls) || (
                    <h5 className="text-white font-roboto-bold text-[15px] leading-[22px]">
                      {item.content.urls[0].name}
                    </h5>
                  )}
                  <div className="flex flex-col gap-y-[18px]">
                    {item.content.urls.map(
                      (itemMenu, indexInside) =>
                        indexInside > 0 && (
                          <Link
                            to={itemMenu.url}
                            className="text-white font-roboto-regular 4xl:text-[15px] text-[13px]
                            leading-[19px]"
                            key={indexInside}>
                            {itemMenu.name}
                          </Link>
                        ),
                    )}
                  </div>
                </div>
              ),
          )}
        <div className="flex flex-col gap-y-12">
          {lastTwo.map((item, index) => (
            <div className="flex flex-col gap-y-[18px] " key={index}>
              <h5 className="text-white font-roboto-bold text-[15px] leading-[22px]">
                {item.content.urls[0].name}
              </h5>
              <div className="flex flex-col gap-y-[18px]">
                {item.content.urls.map(
                  (itemMenu, index) =>
                    index > 0 && (
                      <Link
                        to={itemMenu.url}
                        className="text-white font-roboto-regular 4xl:text-[15px] text-[13px]
                            leading-[19px]"
                        key={index}>
                        {itemMenu.name}
                      </Link>
                    ),
                )}
              </div>
            </div>
          ))}
        </div>
      </motion.div>
    </div>
  );
}
